import React from "react";
import { Div, Text, Checkbox, Image, Icon } from "atomize";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import easyScroll from "easy-scroll";

let startX;

class InfluencerDataBase extends React.Component {
  handleTouchStart = ev => {
    startX = ev.touches[0].clientX;
  };

  handleTouchMove = ev => {
    let touch = ev.touches[0];
    let change = startX - touch.clientX;
    if (change < -10) {
      this.easyScroll("left");
    }
    if (change > 10) {
      this.easyScroll("right");
    }
  };

  easyScroll = change => {
    const db = document.querySelector(".db-tag");
    let scroll = {
      scrollableDomEle: db,
      duration: 200,
      direction: change,
      easingPreset: "easeInQuad",
      scrollAmount: 200,
    };
    easyScroll(scroll);
  };

  render() {
    const { title, differences } = this.props;

    return (
      <WebsiteContainer>
        <CustomContainer p={{ x: { md: "0", lg: "2.5rem" } }}>
          <Div>
            <Div
              m={{ b: { lg: "5rem", xs: "4rem" } }}
              p={{ x: "2rem" }}
              textAlign="center"
            >
              <Text textSize="subheader2" tag="h2" textWeight="400">
                Influencer Databases{" "}
                <strong>
                  <span style={{ borderBottom: "3px solid #9C2626" }}>
                    SUCK.
                  </span>
                </strong>
              </Text>
              <Text
                textWeight="bold"
                m={{ t: ".5rem" }}
                textSize={{ md: "display2", xs: "caption4" }}
                p={{ x: { lg: "0", xs: "3.5rem" } }}
                tag="h3"
              >
                {title}
              </Text>
            </Div>
            <Div
              p={{ t: { xs: "1.1rem" }, l: { xs: "1.5rem", md: "0" } }}
              overflow={{ xs: "auto" }}
              className="db-tag"
              onTouchStart={touchStartEvent =>
                this.handleTouchStart(touchStartEvent)
              }
              onTouchMove={touchMoveEvent =>
                this.handleTouchMove(touchMoveEvent)
              }
            >
              <Div minW="31.25rem">
                <Div
                  d="flex"
                  justify="space-around"
                  w="100%"
                  minW="31.25rem"
                  pos="absolute"
                  transform="translateY(-18px)"
                >
                  <Text
                    m={{ r: "3.75rem" }}
                    d="inline-block"
                    textSize="caption1"
                    textWeight="bold"
                    className="other-platform"
                  >
                    Other Platforms
                  </Text>
                  <Image
                    m={{ r: "3.125rem" }}
                    src="/images/Trend_Black.png"
                    w="4.3rem"
                    h=".8rem"
                    d="inline-block"
                    className="trend-influencer"
                  />
                </Div>
                {differences.map((difference, index) => {
                  return (
                    <Div d="flex" key={index}>
                      <Div
                        d="flex"
                        w="50%"
                        bg="blackGray"
                        m={{ r: ".1rem", b: "1rem" }}
                        p={{ x: "2rem", y: "3.5rem" }}
                      >
                        <Image
                          m={{ r: ".8rem", t: ".3rem" }}
                          h="1.25rem"
                          w="1.25rem"
                          src="/images/red-cross.svg"
                        />
                        <Text textColor="gray700" textSize="paragraph">
                          {difference.other}
                        </Text>
                      </Div>
                      <Div
                        d="flex"
                        bg="blackGray"
                        m={{ b: "1rem" }}
                        w="50%"
                        p={{ x: "2rem", y: "4rem" }}
                      >
                        <Image
                          m={{ r: ".8rem", t: ".3rem" }}
                          h="1.25rem"
                          w="1.25rem"
                          src="/images/gold-check.svg"
                        />
                        <Text textSize="paragraph" textWeight="700">
                          {difference.trend}
                        </Text>
                      </Div>
                    </Div>
                  );
                })}
              </Div>
            </Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}

export default InfluencerDataBase;
